export default __webpack_public_path__ + "static/illustration-united-states.url-8f4f09510ba0eaea237f9e4e2a1304e5.svg";